var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-center align-center",staticStyle:{"height":"89vh"}},[_c('div',{staticClass:"d-flex justify-center align-center loader"},[_c('lottie',{attrs:{"options":_vm.lottieOptions},on:{"animCreated":_vm.handleAnimation}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }